import fetch from 'node-fetch'
class IPAdressFinder{
    constructor(){
        if(document.querySelector('.ip-country-content')){
            this.countryZA = document.querySelectorAll('.ip-country-content--za')
            this.countryINT = document.querySelectorAll('.ip-country-content--int')
            this.currentCountry
            this.getIPAddress()
        }
    }
    // Methods //
    async getIPAddress(){
        try{
            let response = await fetch('https://api.geoapify.com/v1/ipinfo?apiKey=98c3ac60f20240b597c7c95c7a133ac6')
            this.currentCountry = await response.json();
            this.showCountrySpecificContent()
            
        }catch (e){
            console.log(e)
        }
    }
    showCountrySpecificContent(){
        // South Africa
        if(this.currentCountry.country.flag == '🇿🇦'){
            this.countryZA.forEach(el =>{
                el.classList.add('show-content')
            })
        }else{
            this.countryINT.forEach(el =>{
                el.classList.add('show-content')
            })
        }
    }
}

export default IPAdressFinder